import React, { Component } from "react";
import { PageHeader, FormControl, FormGroup, Row, Col } from "react-bootstrap";
import ReactPhoneInput            from "react-phone-input-2";
import LoaderButton               from "../../components/LoaderButton";
import RenderLander               from "../../components/utils/RenderLander";
import TextAreaMod                from "../../components/TextAreaMod";
import FooterLoadingBar           from "../../components/utils/FooterLoadingBar";
import config                     from "../../config";
import { s3PublicUpload }         from "../../libs/awsLib";
import { API, Storage }           from "aws-amplify";
import { Colors }                 from "../../utils/Colors";
import { EmailRegEx }             from "../../utils/EmailRegEx";
import { getImgOrDocTag }         from "../../utils/ImageUpload";
import * as AmazonCognitoIdentity from "amazon-cognito-identity-js";
import ModalAlert                 from "../../components/modal/ModalAlert";
import Resizer from 'react-image-file-resizer';
import {
  CognitoUserPool,
  AuthenticationDetails,
  CognitoUser
} from "amazon-cognito-identity-js";

import "../../css/client/ClientNew.css";

import { invokeAddClientProfile,
         invokeGetNewClientDetail,
         invokeCheckIfClientEmailExists } from "../../utils/AwsInvoke";

const CHAR_COUNT = 1500;
const NOTES_TEXT = "Private notes about the member";

const previewStyle = {
        width: 320,
        height: 320,
        objectFit: 'cover',
        borderRadius: '50%'
}

export default class ClientNew extends Component {
    constructor(props) {
        super(props);

        console.log("User id: " + `${this.props.match.params.id}`);

        this.state = {
              isLoading: false,
              company_id: "",
              client_id: `${this.props.match.params.id}`,
              first_name: "",
              last_name: "",
              email: "",
              phone: "",
              publish: 0,
              notesTextLgth: 0,
              notes:    "",
              loadingData: "",
              showLoadingBar: "none",
              title: "Create New Member",
              inputValue: "",
              previewSrc: "",

              modalAlertTitleText: "",
              modalAlertBodyText:  "",
              showModalAlert:      false, // true | false
              alertObject:         {},
              alertAction:         "",
        };
    }

    componentDidMount() {
        if (!this.props.isAuthenticated) {
            return;
        }

        try {
            //this.getExerciseCategories(jsonData);
            var client_id = this.state.client_id;
            if(this.state.client_id != undefined) {
                this.getClientData(client_id);
            }
        } catch (e) {
            alert(e);
        }
    }

    msgDataLoaded = () => {
        this.setState({
            loadingData: ""
        })
    }

    getClientData = async (client_id) => {

        if(client_id != "undefined") {
                this.setState({
                    title: "Member Profile",
                    loadingData: "Loading exercise data ... "
                })
                const results = await invokeGetNewClientDetail(client_id);

                if(results) {
                    var data        = results.data.client_data[0];
                    var first_name  = data.first_name;
                    var last_name   = data.last_name;
                    var email       = data.email;
                    var phone       = data.phone;
                    var notes       = data.notes;
                    var photo_id    = data.photo_id;

                    if(first_name === null) first_name = "";
                    if(last_name  === null) last_name = "";
                    if(email === null) email = "";
                    if(phone === null) phone = "";
                    if(notes === null) notes = "";
                    if(photo_id === null) photo_id = "";

                    this.setState({
                        first_name: first_name,
                        last_name:  last_name,
                        email:      email,
                        phone:      phone,
                        notes:      notes,
                        photo_id:   photo_id,
                        isLoading:  false
                    });

                    this.msgDataLoaded();
                } else {
                    this.msgDataLoaded();

                }
        } else
            this.setState({ title: "Create New Member" })
    }

    /*********************************************************/
    /****************** Textfield Handlers *******************/
    //// AWS SDK: https://docs.aws.amazon.com/cognito/latest/developerguide/using-amazon-cognito-user-identity-pools-javascript-examples.html

    /*signUp() {//}(email, password) {
        var poolData = {
            UserPoolId : config.cognito.USER_POOL_ID,
            ClientId :   config.cognito.APP_CLIENT_ID
        };
        var userPool = new AmazonCognitoIdentity.CognitoUserPool(poolData);

        var attributeList = [];

        var dataEmail = {
            Name : 'email',
            Value : 'user@test.com'
        };
        var dataPhoneNumber = {
            Name : 'phone_number',
            Value : '+15555555555'
        };

        var attributeEmail = new AmazonCognitoIdentity.CognitoUserAttribute(dataEmail);
        var attributePhoneNumber = new AmazonCognitoIdentity.CognitoUserAttribute(dataPhoneNumber);

        attributeList.push(attributeEmail);
        attributeList.push(attributePhoneNumber);

        userPool.signUp('user@test.com', 'password', attributeList, null, function(err, result){
            if (err) {
                for(var key in err) {
                    console.log("key: " + key);
                    console.log("err: " + err[key]);
                }
                alert("err: " + err);
                return;
            }
            var cognitoUser = result.user;
            console.log('user name is ' + cognitoUser.getUsername());
        });
    }*/

    /*getUserAttributes = () => {
        CognitoUser.getUserAttributes(function(err, result) {
           if (err) {
               alert(err);
               return;
           }
           for (var i = 0; i < result.length; i++) {
               console.log('attribute ' + result[i].getName() + ' has value ' + result[i].getValue());
           }
       });
    }*/

    /*confirmUser = (password) => {
        CognitoUser.confirmRegistration(password, true, function(err, result) {
            if (err) {
                alert(err);
                return;
            }
        });
    }*/

    handleSubmit = async event => {
        event.preventDefault();

        //this.signUp();
        /* */
        var client_id   = this.state.client_id;
        var first_name  = this.state.first_name;
        var last_name   = this.state.last_name;
        var email       = this.state.email;
        var phone       = this.state.phone;
        var notes       = this.state.notes;

        var first_text         = "A First Name is required.";
        var email_text         = "An Email is required.";
        var email_valid_text   = "Please enter a valid email address.";
        var email_exists_text  = "Sorry, the user email exists already. Please use a different one.";

        if(client_id == "undefined") client_id = "new";

        if(first_name === "")
            this.setModalAlertProps("Warning", first_text, true); // title_text, body_text, show_modal
        else if(email === "")
            this.setModalAlertProps("Warning", email_text, true); // title_text, body_text, show_modal
        else if(!EmailRegEx(email)) {
            // If email is not valid
            this.setModalAlertProps("Warning", email_valid_text, true); // title_text, body_text, show_modal
        //else if(phone === "")
        //    this.setModalAlertProps("Warning", phone_text, true); // title_text, body_text, show_modal
        } else {

            try {
                let is_trainer = false;
                let company_id = this.props.globalCompanyId;

                let results_email  = await invokeCheckIfClientEmailExists(email);
                let count          = results_email.count;
                let email_owner_id = results_email.user_id;

                console.log("email_owner_id: " + email_owner_id);
                console.log("client_id: " + client_id);

                ////  Check if the user's id of the email address is the same as the email to be changed to, if it is,
                ////  then no need to check if the email is the same or not; otherwise, the user will never be able to
                ////  change the user's properties like first/last name, etc....
                if(count > 0 && email_owner_id != client_id) {
                    this.setModalAlertProps("Warning", email_exists_text, true); // title_text, body_text, show_modal
                    return
                }

                /*if(client_id === "new") {
                        //let results_email = await invokeCheckIfClientEmailExists(email);
                        //let count = results_email.data;

                        if(count > 0) {
                            this.setModalAlertProps("Warning", email_exists_text, true); // title_text, body_text, show_modal
                            return
                        }
                }*/

                this.setState({ isLoading: true, showLoadingBar: "inline" });
                let photo_id = this.file ? await s3PublicUpload("profile-photos", this.file) : null;

                // If there's an eisting image and a new one hasn't been uploaded, use existing image
                if(photo_id === null || photo_id === undefined)
                    photo_id = this.state.photo_id;

                //const photo_url = await Storage.get(photo_id);
                //console.log("photo_url: " + photo_url);

                const results = await invokeAddClientProfile(client_id, first_name, last_name, email, phone, notes, company_id, photo_id, is_trainer);

                if(results.status === true) {
                    this.setState({
                        isLoading: false,
                        showLoadingBar: "none"
                    });
                    this.goToClientlist();
                } else {
                    var body_text  = "Sorry, we had problems adding the Client. Please try again";
                    this.setModalAlertProps("Warning", body_text, true); // title_text, body_text, show_modal
                    this.setState({ isLoading: false, showLoadingBar: "none" });
                }
            } catch (e) {
                alert(e);
                this.setState({ isLoading: false, showLoadingBar: "none" });
            }
        }/* */
    }

    ////   SHOW THE ALERT MODAL   ////
    setModalAlertProps = (title_text, body_text, show_modal) => {
        var alert_object = {};
        var alert_action = "";

        this.setState({
            modalAlertTitleText: title_text,
            modalAlertBodyText:  body_text,
            showModalAlert:      show_modal, // true | false
            alertObject:         alert_object,
            alertAction:         alert_action
        })
    }

    cancelExercise = () => {
        this.props.history.goBack();
    }

    goToClientlist = () => {
        this.props.history.push("/client/listAll/&");
    }

    handleFirstNameChange  = (event) => {
        var text = event.target.value;
        this.setState({
            first_name: text
        });
    }

    handleLastNameChange  = (event) => {
        var text = event.target.value;
        this.setState({
            last_name: text
        });
    }

    handleEmailChange  = (event) => {
        var text = event.target.value;
        this.setState({
            email: text
        });
    }

    handlePhoneChange  = (text) => {
        this.setState({
            phone: text
        });
    }

    handleNotesChange = (text) => {
        //if(text.length < CHAR_COUNT+1) {
            this.setState({ notes: text, notesTextLgth: text.length});
        //}
    }

    async getAttachment (document_id) {
        var attachmentURL = await Storage.vault.get(document_id);

        this.setState({
            imageURL: attachmentURL
        })
    }

    handlePublish = (event) => {
        this.setState({
            publish: event.target.value
        })
    }

    handleFileChange = event => {
        if (event.target.files && event.target.files[0]) {
            this.file = event.target.files[0];
            var tmp_file_name = this.file.name; // || .size || ".type"
            var file_type = tmp_file_name.substring(tmp_file_name.lastIndexOf(".")+1);

            if(file_type === "jpg" || file_type === "jpeg" || file_type === "gif" || file_type === "png") {
                    this.setState({
                        value: event.target.value
                    });

                    let reader = new FileReader();

                    reader.onload = (e) => {
                        var max_width  = "200px";
                        var max_height = "200px";

                        var img_src_tmp = getImgOrDocTag(e.target.result, file_type, max_width, max_height);

                        /*Resizer.imageFileResizer(
                                        event.target.files[0],
                                        300,
                                        300,
                                        'JPEG',
                                        100,
                                        0,
                                        uri => {
                                            console.log(uri)
                                        },
                                        'base64'
                                    );*/

                        this.setState({
                            imageSrc: img_src_tmp,
                            fileType: file_type
                        });
                    };
                    reader.readAsDataURL(event.target.files[0]);
            } else {
                var body_text  = "Only images can be uploaded.";
                this.setModalAlertProps("Warning", body_text, true); // title_text, body_text, show_modal
            }
        }
    }

    renderHome() {
        var publishNo = false;
        var publishYes = false;

        if(this.state.publish == "Yes" || this.state.publish === 1 )
            publishYes = true;
        else
            publishNo = true;


        var textfield =  <FormGroup controlId="file">
                                <Row className="grid">
                                      <Col xs={12} sm={12} md={12}>
                                          <span className="formLabel">
                                              Profile Photo
                                          </span>
                                      </Col>
                                </Row>
                                <Row className="grid">
                                      <Col xs={12} sm={12} md={12}>
                                          <span className="formLabel pull-left" style={{width:"100%", textAlign:"left"}}>
                                              {this.state.imageSrc}
                                          </span>
                                      </Col>
                                </Row>
                                { /*}<div>
                                    <PhotoPicker
                                        title="Select a file"
                                        preview={"hidden"}
                                        onLoad={ url => this.setState({previewSrc: url})}
                                    />
                                    <img src={this.state.previewSrc} style={previewStyle} />
                                </div>*/ }
                                <Row className="grid">
                                      <Col xs={12} sm={12} md={12}>
                                          <span style={{paddingLeft:"48%", width:"100%",  border:"0px solid #000"}}>
                                                <label id="documentFile"> Upload Image
                                                        <FormControl onChange = {this.handleFileChange}
                                                                     style    = {{outline:"none", display: "none", fontSize:"16px", width:"100px" /*width = hide text: 'no file chosen' */}}
                                                                     value    = {this.state.inputValue}
                                                                     type     = "file" />
                                                </label>
                                             </span>
                                         </Col>
                                   </Row>

                            </FormGroup>

        return (
          <div className="programs">
            <PageHeader>
                    { this.state.title }
                    <span style={{fontSize:"16px", color: "red"}}><br/>{ this.state.loadingData }</span>
            </PageHeader>

            <form onSubmit={this.handleSubmit} className="form">
                    { textfield }
                    <div className="iconAddExercise25pxVertSpacer"></div>

                    { /********* FIRST NAME *********/ }
                    <Row className="grid">
                          <Col xs={12} sm={12} md={12}>
                              <span className="formLabel">
                                  First Name
                              </span>
                          </Col>
                    </Row>
                    <Row className="grid">
                          <Col xs={12} sm={12} md={12}>
                              <span>
                                    <input type        = "text"
                                           placeholder = "First Name"
                                           value       = {this.state.first_name}
                                           onChange    = {this.handleFirstNameChange.bind(this)}
                                           className   = "input-lg tf_addExercise" />

                              </span>
                          </Col>
                    </Row>
                    { /********* LAST NAME *********/ }
                    <div className="iconAddExercise25pxVertSpacer"></div>
                    <Row className="grid">
                          <Col xs={12} sm={12} md={12}>
                              <span className="formLabel">
                                  Last Name
                              </span>
                          </Col>
                    </Row>
                    <Row className="grid">
                          <Col xs={12} sm={12} md={12}>
                              <span>
                                      <input type="text"
                                             placeholder = "Last Name"
                                             value={this.state.last_name}
                                             onChange  = {this.handleLastNameChange.bind(this)}
                                             className = "input-lg tf_addExercise" />
                              </span>
                          </Col>
                    </Row>

                    { /********* EMAIL *********/ }
                    <div className="iconAddExercise25pxVertSpacer"></div>
                    <Row className="grid">
                          <Col xs={12} sm={12} md={12}>
                              <span className="formLabel">
                                  Email
                              </span>
                          </Col>
                    </Row>
                    <Row className="grid">
                          <Col xs={12} sm={12} md={12}>
                              <span>
                                     <input type="text"
                                            placeholder = "Email Address"
                                            value={this.state.email}
                                            onChange  = {this.handleEmailChange.bind(this)}
                                            className = "input-lg tf_addExercise" />

                              </span>
                          </Col>
                    </Row>

                    { /********* Phone *********/ }
                    <div className="iconAddExercise25pxVertSpacer"></div>
                    <Row className="grid">
                          <Col xs={12} sm={12} md={12}>
                              <span className="formLabel">
                                  Phone Number
                              </span>
                          </Col>
                    </Row>
                    <Row className="grid">
                          <Col xs={12} sm={12} md={12}>
                             { /*} <span>
                                    <input type        = "text"
                                           className   = "input-lg tf_addExercise"
                                           style       = {{float:"left",width:"200px"}}
                                           placeholder = "Phone Number"
                                           value       = {this.state.phone}
                                           onChange    = {this.handlePhoneChange.bind(this)}/>
                                   </span> */ }
                              <ReactPhoneInput defaultCountry={'us'}
                                               value       = {this.state.phone}
                                               onChange={this.handlePhoneChange.bind(this)}/>
                          </Col>
                    </Row>

                    { /********* NOTES *********/ }
                    <div className="iconAddExercise25pxVertSpacer"></div>
                    <Row className="grid">
                          <Col xs={12} sm={12} md={12}>
                              <span className="formLabel">
                                    Notes
                              </span>
                          </Col>
                    </Row>
                    <Row className="grid">
                          <Col xs={12} sm={12} md={12}>
                              <span style={{textDecoration: "none"}}>
                                  <TextAreaMod placeholder  = {NOTES_TEXT}
                                               value        = {this.state.notes}
                                               handleChange = {this.handleNotesChange.bind(this)}
                                         />
                              </span>
                              <br/><br/>
                          <span className="textLabelCounter">Chars remaining: { /*CHAR_COUNT-this.state.notesTextLgth*/ }</span>
                          </Col>
                    </Row>


                    <div className="iconAddExercise25pxVertSpacer"></div>
                    { /*}<Row className="grid">
                          <Col xs={12} sm={12} md={12}>
                              <span className="formLabel">

                                        Submit to TS for Review: <br/>
                                          <Radio name="radioGroup"
                                                 inline
                                                 checked={publishNo}
                                                 value = "No"
                                                 onChange = {this.handlePublish.bind(this)}>
                                                 No
                                          </Radio>{' '}
                                          <Radio name="radioGroup"
                                                 inline
                                                 checked={publishYes}
                                                 value = "Yes"
                                                 onChange = {this.handlePublish.bind(this)}>
                                            Yes
                                          </Radio>

                              </span>
                          </Col>
                    </Row>*/ }
                <div className="iconAddExerciseVertSpacer"></div>
                <Row className="grid">
                      <Col xs={6} sm={6} md={6}>
                          <span onClick = { () => this.cancelExercise()}>
                              <LoaderButton
                                block
                                type    = "button"
                                text    = "Cancel"
                                style   = {{ fontSize:18, height:42, color:"black", backgroundColor: "#ccc"}}
                              />
                          </span>
                        </Col>
                        <Col xs={6} sm={6} md={6}>
                              <LoaderButton
                                  block
                                  style   = {{ fontSize:18, height:42, color:"white", fontWeight: "bold", backgroundColor: Colors.ok_button_bg}}
                                  //disabled={!this.validateForm()}
                                  isLoading={this.state.isLoading}
                                  text    = "Submit"
                                  type    = "submit"
                                  loadingText="Saving …"
                              />
                        </Col>
                    </Row>
            </form>
            <br/><br/><br/><br/><br/>
          </div>
        );
    }

    render() {
        let closeModalAlert        = () => this.setState({ showModalAlert: false }); //close simple modal window

        return (
              <div className="Home">
                {this.props.isAuthenticated ? this.renderHome() : <RenderLander />}

              {this.state.showModalAlert ?
                  <ModalAlert
                      onHide         = {closeModalAlert}
                      alertFunction  = {this.alertFunction}     // custom function to call within modal
                      alertAction    = {this.state.alertAction} // flag used for above function
                      alertObject    = {this.state.alertObject} // vars used for above function
                      showModalAlert = {this.state.showModalAlert}
                      messageTitle   = {this.state.modalAlertTitleText}
                      messageBody    = {this.state.modalAlertBodyText}
                  />
              : null}

              <FooterLoadingBar text={"Saving New Member Data..."}
                                showLoadingBar={this.state.showLoadingBar}/>
              </div>
        );
  }
}



// WEBPACK FOOTER //
// ./src/screens/client/ClientNew.js